export enum TypeHabilitationEnum {
    Autre = 0
}